import "./Testimonials.css";

export const Testimonials = () => {
  return (
    <div className="testimonials-container">
      <h1>Testimonials</h1>
      <p className="testimonial-description">From November 2017:</p>
      <p className="testimonial-text">
        Hi Jonathan
        <br />
        <br />
        I received my CD today taken from a 40 year old tape and it is really
        incredible to hear it after all this time.
        <br />
        <br />
        The quality of the CD is superb - much better than I imagined and it has
        been a real pleasure to deal with you.&nbsp; Good luck for future
        business and I definitely recommend you should someone require your
        services.&nbsp; Very many thanks, best regards Jacky
      </p>
      <p className="testimonial-description">From October 2016:</p>
      <p className="testimonial-text">
        Really Great Job. Clearer than the original cassette!!
      </p>
      <p className="testimonial-description">From September 2016:</p>
      <p className="testimonial-text">
        Just received the CD and it&rsquo;s FANTASTIC!!!&nbsp; Thank you so
        much!
      </p>
      <p className="testimonial-description">Another quote from September:</p>
      <p className="testimonial-text">
        Dear Jonathan,
        <br />
        The CDs arrived today.
        <br />
        You have done a brilliant job.
        <br />
        My son was born in New York and we lived
        <br />
        there until he was 3 so it is great to hear him
        <br />
        with an American accent.
        <br />
        Thank you so much
      </p>
      <p className="testimonial-description">From November 2015:</p>
      <p className="testimonial-text">
        Dear Jonathan,
        <br />
        Amazing and extraordinary!! Thank you SO SO much! It is just wonderful
        to hear Marye again. Very best wishes. Lianne.
      </p>
      <p className="testimonial-description">From January 2015:</p>
      <p className="testimonial-text">
        Hi Jonathan, Just wanted to say thank you for transferring the audio
        tape onto CD. You have done an excellent job and I can recognise all of
        the voices. I&rsquo;ll be dropping the discs over to my parents later
        this week and I know that they are going to really enjoy listening to
        them again after all these years. Thanks again,&nbsp;
      </p>
      <p className="testimonial-description">From June 2014:</p>
      <p className="testimonial-text">
        Hi Jonathan. I got my cd yesterday and I just felt the need to send you
        a quick thank you. I had resigned myself to playing my LP once every ten
        years or so whenever I could be bothered to set my turntable up. I
        always thought that any digital conversion would only ever be adequate
        and for me that wouldn't be good enough. I can't call myself a
        connoisseur as I haven't got the sort of money that buys that sort of
        system! I am however, very discerning and the cd you produced for me is
        more than I could have hoped for. I thank you so much for bringing back
        an LP to me which is now once again a part of my life. Probably sounds a
        bit over the top but you have made me a very happy man! And your
        customer service has been excellent from your first prompt reply to my
        original enquiry.
      </p>
      <p className="testimonial-description">
        An LP we transferred in May 2013:
      </p>
      <p className="testimonial-text">
        Jonathan transferred a mid 1970's LP to CD for me &amp; sound quality is
        amazing - it sounds like a state of the art 2013 recording &amp; the job
        was done quickly &amp; more than professionally!
      </p>
      <p className="testimonial-description">
        Some feedback from May 2013 - Chris says it all:
      </p>
      <p className="testimonial-text">
        Hi. I&rsquo;m now back in the West Country having, thanks to you, been
        able to bring you two recently re-discovered fifty-year-old (and very
        badly recorded!) tapes of a school leavers&rsquo; concert my way up to a
        re-union in the Midlands, collect them within days, and thus have them
        available at the re-union. Not only did you respond to the urgency with
        huge good grace, but you overcame virtually all the technical
        shortcomings of our schoolboy recordings (and those attributable to the
        sheer age of the tapes); you edited them to perfection (and totally
        undetectably!) to leave out all the tedious &lsquo;scene-changing&rsquo;
        silences, and then presented them in immaculately art-worked and highly
        flattering crystal-case boxes &ndash; and all at a very acceptable
        price. Absolutely wonderful! Thank you so much! So, be warned; as and
        when I may re-discover anything more of the same, you will definitely be
        the automatic first choice to transfer them up onto CD!
      </p>
      <p className="testimonial-description">
        I&nbsp;have transferred several LPs of varying genres for Haylyn and he
        is a very loyal customer and this is just one of his comments:
      </p>
      <p className="testimonial-text">
        I received it (the LP) last week, surprised that you had quickly done
        it. It was a brilliant transfer, just like if issued by a commercial
        company. I'd love to know what equipment you use, because the transfers
        are so professional. I have had some done by another person which were
        awful, which I never pursued again. I will be sending you another lp
        this week if it' s ok.
      </p>
      <p className="testimonial-description">
        Throughout 2011 and into 2012 - Ken records his songs to mini disc and
        we convert them to CD and produce bespoke CD covers.
      </p>
      <p className="testimonial-text">
        Hi Jonathan, just like to say a big thank you for transferring my latest
        minidisc and congratulate you on your expertise not only on the quality
        of the sound which is excellent but also on the transfer of my
        photographs onto the cd cover, and also on to the disc itself, quite
        brilliant. I would like you to put this message into your testimonial
        section to assure potential customers that your work is absolutely first
        class, I say this because I dealt with two of your competitors before I
        found your company and was totally let down by them, not only was their
        work atrocious but they were obnoxious when I contacted them, I spent
        close on &pound;300.00 between them and ended up putting their discs in
        the dustbin, I will get my latest disc off to you when its ready, yours
        respectfully Kenneth James Darby.&nbsp;
      </p>
      <p className="testimonial-description">
        September 2011, John had 3 studio master reels with Dolby noise
        reduction:
      </p>
      <p className="testimonial-text">
        Hi Jonathan, Just wanted to drop you a line to tell you what a brilliant
        job you made of the three tapes &ndash; the quality (especially given
        the treatment they have had over the decades) is really astonishing, in
        fact it sounded pretty much as it did straight off the original 4-track
        back in the late 70&rsquo;s. I&rsquo;ve listened to all of it now, and
        it brought back memories of a time I never thought I would be able to
        revisit &ndash; I&rsquo;m so glad now that I hung on to those old
        reel-to-reel tapes. You did a good thing and I&rsquo;m very grateful.
      </p>
      <p className="testimonial-description">
        May 2009, Lesley had a reel to reel of family members:
      </p>
      <p className="testimonial-text">
        Hi Jonathan, We received the CD this morning and we have just listened
        to it, what can I say?, you have made my husband so happy, my husband
        came to England to work in a hospital 45 years ago, his mother died
        suddenly soon after he arrived here and he never thought he would hear
        her voice again. I never met her, but today I feel that we have met for
        the first time. The quality is so good, and the tape is so clear and
        gets better and better as it goes on. Thank you so much Jonathan kindest
        regards
      </p>
      <p className="testimonial-description">
        Lesley Graham had two rare LPs he wanted transferring to CD (June 2009):
      </p>
      <p className="testimonial-text">
        Hi Jonathan, I don't know how you do it but the sound quality is
        amazing. The Pattersons sound even better than they did on vinyl. I have
        no hesitation in recommending your services. Many thanks.
      </p>
      <p className="testimonial-description">
        Ann had an LP which she wanted to upload to iTunes (Nov 2007);
      </p>
      <p className="testimonial-text">
        Dear Jonathan, We have just finished listening to 'THE TAILORS OF
        POZNANCE" on big speakers and we are thrilled to bits with your work.
        The reproduction is beyond our wildest dreams and Iain felt he was
        transported back to the studio where he recorded it. The quality of the
        recording was so good that he felt he was in the control room at the
        recording studio in 1967 listening to the playbacks. You have done a
        superb job and we are so grateful to you. There will be more work coming
        your way - we would not go to anyone else and we will recommend you to
        our friends and colleagues in the business.
      </p>
      <p className="testimonial-description">
        Liz had a reel to reel with 2 hours of family archive material;
      </p>
      <p className="testimonial-text">
        Hi Jonathan, I received the CDs this morning and played one before going
        to work, WOW they are really brilliant thanks for doing such a good job
        of it. That reel to reel tape is 41 years old, most of the people on it
        have now died so those tapes will hold special memories for some of
        thier families including mine, my father died 30 years ago and it was so
        lovely to hear his voice so clearly again it made my day. So thank you,
        I would definately recommend you to anyone and when I sort out the rest
        of the tapes would love to get some more transferred. Regards
      </p>
      <p className="testimonial-description">
        Liz Stuart had a particular set of recordings of 'The Messiah' on 3 x
        78s and wanted them transferred to CD. This was quite a challenge as
        there were some nasty scratches on one of the records...
      </p>
      <p className="testimonial-text">
        'The scratches you mentioned are hardly noticeable on the CD. I don't
        know what the effects are like on a CD. I'm delighted with the results.
        It was recorded in an era of superb singing and a great addition to my
        collection of Wilfred Brown's performances.'
      </p>
      <p className="testimonial-description">
        Jenny had two cassettes of her son's perfomances when he was in his
        schools swing band...
      </p>
      <p className="testimonial-text">
        ' I have now had the opportunity to listen to the CD's and to let you
        know just how superb I think they are, so very clear and crisp .... they
        seem to have come 'alive', my son is going to be so surpised and
        thrilled with them. You are a real find, thanks again...'
      </p>
      <p className="testimonial-description">
        Simon had a collection of 20 LPs he needed transferring to CD...
      </p>
      <p className="testimonial-text">
        "Dear Jonathan, I have listened to some of the recordings and I must say
        that I am mightlily impressed and the results are better than I thought
        possible."&nbsp;
      </p>
      <p className="testimonial-description">
        Izabel wrote after receiving an album we transferred for her husband's
        birthday..
      </p>
      <p className="testimonial-text">
        "Just wanted to let you know the LP and CD arrived safely on Saturday.
        Steve, my husband is absolutely thrilled with it. He even switched off
        the football to listen to it - that's how pleased he was. His favourite
        track - Alfie - used to be very 's'y - or perhaps that was just a
        feature of his record deck - but you've worked wonders. Thankyou so
        much. We'll now go through the rest of the collection - and I'll
        definitely recommend you."
      </p>
      <p className="testimonial-description">
        Channelle from London who had a 78 of her grandfather singing from 1955
        and needed it transferred for Christmas - we received it on the 22nd
        December:
      </p>
      <p className="testimonial-text">
        "Thank you so much for the transfer my Grandfather was delighted and
        said it was the best present he's ever had."
      </p>
      <p className="testimonial-description">
        Paul had several cassettes with archive material from interviews with
        family members, some as old as 93. The tapes had varying degrees of
        noise and volume levels. The resulting CDs were:
      </p>
      <p className="testimonial-text">"..excellent quality. Many thanks."</p>
      <p className="testimonial-description">
        Keren from London wanted a rare album unavailable on CD transferred for
        her father's birthday.
      </p>
      <p className="testimonial-text">
        "..thanks very much I've just listened to the CD and I'm really
        pleased.."
      </p>
    </div>
  );
};
